var __jsx = React.createElement;
import React from "react";
import { useLang } from "@/common/Contexts/LanguageContext";
import { ucWords } from "@/utils/stringHelpers";
var CarInfo = function CarInfo(_ref) {
  var _sellTradeItem$make, _sellTradeItem$make2, _sellTradeItem$model, _sellTradeItem$model2, _sellTradeItem$make3;
  var sellTradeItem = _ref.sellTradeItem;
  var lang = useLang();

  // Extract data from sellTradeItem with optional chaining
  var brandName = lang === "ar" ? sellTradeItem === null || sellTradeItem === void 0 ? void 0 : (_sellTradeItem$make = sellTradeItem.make) === null || _sellTradeItem$make === void 0 ? void 0 : _sellTradeItem$make.name_ar : sellTradeItem === null || sellTradeItem === void 0 ? void 0 : (_sellTradeItem$make2 = sellTradeItem.make) === null || _sellTradeItem$make2 === void 0 ? void 0 : _sellTradeItem$make2.name_en;
  var modelName = lang === "ar" ? sellTradeItem === null || sellTradeItem === void 0 ? void 0 : (_sellTradeItem$model = sellTradeItem.model) === null || _sellTradeItem$model === void 0 ? void 0 : _sellTradeItem$model.name_ar : sellTradeItem === null || sellTradeItem === void 0 ? void 0 : (_sellTradeItem$model2 = sellTradeItem.model) === null || _sellTradeItem$model2 === void 0 ? void 0 : _sellTradeItem$model2.name_en;
  var logoUrl = sellTradeItem === null || sellTradeItem === void 0 ? void 0 : (_sellTradeItem$make3 = sellTradeItem.make) === null || _sellTradeItem$make3 === void 0 ? void 0 : _sellTradeItem$make3.logo;
  var year = parseInt(sellTradeItem.year);
  return /*#__PURE__*/React.createElement("div", {
    id: "car-info-".concat(sellTradeItem.request_id || sellTradeItem.id),
    className: "flex items-center justify-center shrink-0"
  }, /*#__PURE__*/React.createElement("div", {
    id: "car-info-logo-container-".concat(sellTradeItem.request_id || sellTradeItem.id),
    className: "w-10 h-10 md:w-12 md:h-12 flex items-center justify-center mx-1 md:mx-3"
  }, /*#__PURE__*/React.createElement("img", {
    id: "car-info-logo-".concat(sellTradeItem.request_id || sellTradeItem.id),
    src: logoUrl,
    alt: brandName,
    className: "w-8 h-8 md:w-10 md:h-10 object-contain"
  })), /*#__PURE__*/React.createElement("div", {
    id: "car-info-details-".concat(sellTradeItem.request_id || sellTradeItem.id),
    className: "flex flex-col mx-1 md:mx-5"
  }, /*#__PURE__*/React.createElement("h2", {
    id: "car-info-brand-".concat(sellTradeItem.request_id || sellTradeItem.id),
    className: "text-base md:text-2xl font-bold text-gray-900 mb-1"
  }, ucWords(brandName)), /*#__PURE__*/React.createElement("p", {
    id: "car-info-model-year-".concat(sellTradeItem.request_id || sellTradeItem.id),
    className: "text-gray-500 text-xs md:text-base whitespace-nowrap"
  }, modelName, " ", year)));
};
export default CarInfo;